var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('org-chart',{attrs:{"datasource":_vm.ds},on:{"node-click":_vm.nodeClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }